import React, { useEffect, useState } from "react"
import CTA from "../../atoms/CTA"
import SectionHeader from "../../molecules/SectionHeader"
import SwiperCore, { Mousewheel, Scrollbar } from "swiper"
import "./styles.scss"
import "swiper/components/scrollbar/scrollbar.scss"
import memojiPath from "../../../assets/images/memoji/our-team.gif"

import "swiper/swiper.scss"
SwiperCore.use([Mousewheel, Scrollbar])

const AboutUs = ({ button, members, title, subtitle, icons, isDesktop }) => {
  const [activeIcon, setActiveIcon] = useState(0)

  useEffect(() => {
    setActiveIcon(icons[0].url)
  }, [])

  return (
    <section className="section section--aboutUs">
      <div className="wrapper">
        <div className="aboutUs__content">
          <SectionHeader
            className="aboutUs__title"
            type="h2"
            subtitle={subtitle}
            animate={true}
            attributes={{
              "data-sal": "slide-up",
              "data-sal-duration": "1000",
              "data-sal-easing": "ease",
            }}
          ></SectionHeader>
          <p
            className="aboutUs__description"
            // onMouseMove={e => changeInlines(e)}
            // onMouseLeave={() => setRandomAnimoji()}
          >
            We build world-class digital products. Our dedicated teams{" "}
            <span className="inline inline--memoji">
              <img src={memojiPath} />
            </span>{" "}
            are the right blend of creative{" "}
            <i
              className="inline inline--icon"
              style={{ backgroundImage: `url(${activeIcon})` }}
            ></i>{" "}
            and technical to deliver you value more efficiently.
          </p>
          <CTA className="btn--bordered" to="/about/">
            {button.title}
          </CTA>
        </div>
      </div>
    </section>
  )
}

export default AboutUs
